class CalculateProducts{
    constructor(){
        this.items = 0
        this.models = 0
    }
    
    clear(){
        this.items = 0
        this.models = 0
    }

    calculate(list){
        this.clear()
        list.forEach(ss=>{
            this.items += ss.amount
            this.models ++
        })
    }
}

export default CalculateProducts